import React, {ReactElement} from "react";
import {Route} from "react-router-dom";
import PatchNotesPage from "../../pages/chase/site/patch-notes/PatchNotesPage";
import CreditsPage from "../../pages/chase/site/credits/CreditsPage";
import DownloadsPage from "../../pages/chase/fun/downloads/DownloadsPage";
import DownloadSuperFoxPage from "../../pages/chase/fun/downloads/super-fox/DownloadSuperFoxPage";

class SiteInfoRouter {

    public static getRoutes(): ReactElement {
        return (
            <>
                <Route path="credits">
                    <Route index element={<CreditsPage/>}/>
                </Route>
                <Route path="patch-notes" element={<PatchNotesPage/>}/>
                <Route path="downloads">
                    <Route index element={<DownloadsPage/>}/>
                    <Route path="super-fox">
                        <Route index element={<DownloadSuperFoxPage/>}/>
                    </Route>
                </Route>
            </>
        );
    }
}

export default SiteInfoRouter;